<template>
  <!-- eslint-disable vue/no-v-html -->
  <Component
    :is="type"
    :aria-label="ariaLabel"
    :class="['icon', size]"
    v-html="svg"
  />
</template>

<script>
const req = require.context('@public/media/icons', true, /^\.\/.*\.svg$/);

/**
 * Icons are used to visually communicate core parts of the product and
 * available actions. They can act as wayfinding tools to help users more
 * easily understand where they are in the product.
 */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Icon',
  props: {
    /**
     * The name of the icon to display.
     */
    name: {
      required: true,
      type: String,
      default: 'settings',
    },
    /**
     * The fill color of the SVG icon.
     */
    fill: {
      type: String,
      default: 'currentColor',
    },
    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: 'icon',
    },
    /**
     * The html element name used for the icon.
     */
    type: {
      type: String,
      default: 'span',
    },
    /**
     * The size of the icon. Defaults to medium.
     * `small, medium, large`
     */
    size: {
      type: String,
      default: 'medium',
      validator: (value) => {
        return value.match(/(small|medium|large)/);
      },
    },
  },
  data() {
    return {
      svg: req(`./${this.name}.svg`).replace(/^<svg /, `<svg style="fill: ${this.fill}" `),
    };
  },
};
</script>

<style lang="scss">
// We don’t want to use scoped since these styles need to cascade down to SVGs.
// We also want to be able to style .icon inside buttons etc.
@import '@src/components/Icons/style/icon.scss';
</style>
